export default "__VITE_ASSET__DqeYokO3__"